import { render, staticRenderFns } from "./EmailTemplates.vue?vue&type=template&id=a4535de0&"
import script from "./EmailTemplates.vue?vue&type=script&lang=js&"
export * from "./EmailTemplates.vue?vue&type=script&lang=js&"
import style0 from "./EmailTemplates.vue?vue&type=style&index=0&id=a4535de0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports